export default {"header":"header-module__header__EftWT","inner":"header-module__inner__6tKjN","link":"header-module__link__gPS68"};